<template>
  <div class="contract-info">
    <el-tabs v-model="query.signed_status" @tab-click="handleSearch(1)">
      <el-tab-pane label="全部合同" name="-1"></el-tab-pane>
      <el-tab-pane label="准备中" name="5"></el-tab-pane>
      <el-tab-pane label="我方未签署" name="0"></el-tab-pane>
      <el-tab-pane label="对方未签署" name="3"></el-tab-pane>
      <el-tab-pane label="已完成" name="4"></el-tab-pane>
      <el-tab-pane label="取消" name="6"></el-tab-pane>
    </el-tabs>
    <div class="contract-search">
      <div>
        <span>交易账号</span>
        <el-input
          class="input-120 mr-10"
          v-model="query.sell_game_account"
          placeholder="请输入交易账号"
          clearable
          @keydown.enter.native="handleSearch(1)"
        ></el-input>
      </div>
      <div>
        <span>订单号</span>
        <el-input
          class="input-120 mr-10"
          v-model="query.order_no"
          placeholder="请输入订单号"
          clearable
          @keydown.enter.native="handleSearch(1)"
        ></el-input>
      </div>
      <div>
        <span>游戏</span>
        <el-select
          v-model="query.game_id"
          filterable
          clearable
          :popper-append-to-body="false"
          @change="handleSearch(1)"
          class="input-120"
        >
          <el-option
            v-for="item in gameList"
            :label="item.game_name"
            :value="item.game_id"
            :key="item.game_id"
          ></el-option>
        </el-select>
      </div>
      <div>
        <span>保障文件</span>
        <el-select
          v-model="query.is_buy_benefit"
          filterable
          clearable
          :popper-append-to-body="false"
          @change="handleSearch(1)"
          class="input-120"
        >
          <el-option
            label="全部"
            value=""
          ></el-option>
          <el-option
            label="交易合同"
            value="1"
          ></el-option>
          <el-option
            label="包赔文件"
            value="2"
          ></el-option>
        </el-select>
      </div>
      <div class="search-btn">
        <el-button type="primary" @click="handleSearch(1)" round>搜索</el-button>
      </div>
    </div>
    <div class="contract-table">
      <el-table :data="tableData" v-loading="loading">
        <template slot="empty">
          <div class="contract-empty">
            <empty-state
              title="暂无合同信息"
              description="可以调整筛选条件后再次查看"
              icon="el-icon-document"
              :icon-size="52">
            </empty-state>
          </div>
        </template>
        <el-table-column
          v-for="(item, index) in tableColumn"
          :label="item.label"
          :prop="item.prop"
          align="center"
          :key="index"
          :show-overflow-tooltip="true"
          :min-width="item.minWidth"
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'signed_status'">
              <!-- v-if="scope.row.show_benefit_url==0" -->
              <div
                :class="
                  scope.row[item.prop] == 4
                    ? 'all-over'
                    : scope.row[item.prop] == 5
                    ? 'ing-over'
                    : scope.row[item.prop] == 6
                    ? 'cancel-over'
                    : 'no-over'
                "
              >
                {{
                  scope.row[item.prop] === 0
                    ? "我方未签署"
                    : scope.row[item.prop] == 3
                    ? "对方未签署"
                    : scope.row[item.prop] == 4
                    ? "已完成"
                    : scope.row[item.prop] == 5
                    ? "准备中"
                    : scope.row[item.prop] == 6
                    ? "取消"
                    : ''
                }}
              </div>
              <!-- <div v-else>———</div> -->
            </div>
            <div v-else-if="item.prop === 'unique_no'" style="margin-left: 5px;">
              {{ scope.row.unique_no }}
            </div>
            <div v-else-if="item.prop === 'sign_way'">
              {{ scope.row.sign_way == 1 ? '交易合同' : scope.row.sign_way == 2 ? '包赔文件' : '————' }}
            </div>
            <div v-else-if="item.prop === 'buy_name'">
              <div>{{ scope.row.buy_name }}</div>
              <div>{{ scope.row.sell_name }}</div>
              <!-- <div>{{ scope.row.is_benefit == 3 ? '游严选代售' : scope.row.buy_name }}</div>
              <div v-if="scope.row.show_benefit_url==0">{{ scope.row.is_benefit == 2 ? '游严选代售' :scope.row.sell_name }}</div> -->
            </div>
            <template v-else-if="item.prop === 'initiate_time' || item.prop === 'signed_time'">
              {{ $formatDate(scope.row[item.prop],'YYYY-MM-DD') }}
            </template>
            <template v-else>{{ scope.row[item.prop] }}</template>
          </template>
        </el-table-column>
        <el-table-column align="left" label="操作" width="176" fixed="right">
          <template slot-scope="scope">
            <el-link
              class="contract-link"
              :underline="false"
              v-if="scope.row.signed_status == 4"
              @click="downContract(scope.row)"
            >
              <i class="iconfont pxb7-contract-down"></i>下载
            </el-link>
            <el-link
              class="contract-no-border"
              :underline="false"
              v-if="scope.row.signed_status == 4"
              @click="selectCnontract(scope.row)"
            >
              <i class="iconfont pxb7-eye"></i>预览
            </el-link>
            <el-link
              class="contract-link"
              :underline="false"
              v-if="scope.row.signed_status == 0"
              @click="signContract(scope.row)"
            >
              <i class="iconfont pxb7-contract-sign"></i>签署
            </el-link>
            <el-link
              class="contract-no-border"
              :underline="false"
              v-if="scope.row.signed_status == 3"
              @click="selectCnontract(scope.row)"
            >
              <i class="iconfont pxb7-eye"></i>查看
            </el-link>
            <!-- <el-link
              class="contract-link"
              :underline="false"
              v-if="scope.row.signed_status !== 0"
              @click="downContract(scope.row.id)"
            >
              <i class="el-icon-download"></i>下载合同
            </el-link> -->
            <!-- <el-link
              class="contract-link"
              :underline="false"
              v-if="scope.row.signed_status !== 0"
              @click="selectCnontract(scope.row.id)"
            >
              <i class="el-icon-search"></i>查看合同
            </el-link> -->
            <!-- <div v-if="scope.row.signed_status !== 0&&scope.row.show_benefit_url == 0" class="link_group">
              <div v-if="scope.row.is_history === 1">
                <span
                  :underline="false"
                  @click="selectCnontract(scope.row.id)"
                >
                  预览
                </span>
              </div>
              <div v-else>
                <el-link
                  :underline="false"
                  @click="downContract(scope.row.id)"
                >
                  下载
                </el-link>
                <el-link
                  :underline="false"
                  @click="selectCnontract(scope.row.id)"
                >
                  查看
                </el-link>
              </div>
            </div>
            <el-link
              class="contract-link"
              :underline="false"
              v-if="scope.row.signed_status === 0&&scope.row.show_benefit_url == 0&&scope.row.contract_no!=''&&scope.row.contract_no!=null"
              @click="signContract(scope.row)"
            >
              <i class="el-icon-edit"></i>签署合同
            </el-link>
            <el-link
              class="contract-link no-hover"
              :underline="false"
              v-if="scope.row.signed_status === 0&&scope.row.show_benefit_url == 0&&(scope.row.contract_no==''||scope.row.contract_no==null)"
            >
              合同起草中
            </el-link>
            <el-link
              class="contract-link"
              :underline="false"
              v-if="scope.row.show_benefit_url == 1&&scope.row.benefit_prove_url!=''"
              @click="downIndemnity(scope.row.benefit_prove_url)"
            >
              下载包赔文件
            </el-link> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="contract-pages" v-if="totalCount > query.pageSize">
      <common-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="query.page"
        :page-size="query.pageSize"
        layout="prev, pager, next, jumper"
        :total="totalCount">
      </common-pagination>
    </div>
    <el-dialog
      :visible.sync="dialogSignature"
      top="32vh"
      :show-close="false"
      custom-class="contract-before"
      width="360px">
      <div class="signature-dia">
        <div class="signature-icon">
          <i class="el-icon-document"></i>
        </div>
        <div class="signature-footer">
          合同正在起草中，请稍等！
        </div>
        <div class="signature-desc">
          文件生成完成后即可继续签署，请稍后刷新查看。
        </div>
        <el-button class="signature-confirm" type="primary" @click="dialogSignature = false">
          知道了
        </el-button>
        <img class="close" src="@/assets/image/AccountDeal/close.png" alt="" @click="dialogSignature = false">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  apiGameList,
  apiContractList,
  apiDownloadContract,
  apiContractSigned,
  apiContractVerify,
  apiViewContract
} from "@/request/API";
import CommonPagination from "@/components/commonPagination";
import EmptyState from "@/components/emptyState";

export default {
  name: "ContractInfo",
  components: {
    CommonPagination,
    EmptyState
  },
  data() {
    return {
      loading: false,
      query: {
        signed_status: "-1",
        sell_game_account: "",
        order_no: '',
        game_id: "",
        // 默认显示第几页
        page: 1,
        // 默认每页显示的条数
        pageSize: 6,
        is_buy_benefit: ''
      },
      tableData: [],
      tableColumn: [
        { label: "订单号", prop: "order_no", minWidth: 170 },
        { label: "游戏", prop: "game_name", minWidth: 110 },
        { label: "商品编号", prop: "unique_no", minWidth: 150 },
        { label: "交易账号", prop: "sell_game_account", minWidth: 150 },
        { label: "保障文件类型", prop: "sign_way", minWidth: 130 },
        { label: "状态", prop: "signed_status", minWidth: 120 },
        { label: "签约人", prop: "buy_name", minWidth: 130 },
        { label: "发起时间", prop: "initiate_time", minWidth: 120 },
        { label: "完成时间", prop: "signed_time", minWidth: 120 },
      ],
      // 总条数，根据接口获取数据长度
      totalCount: 0,
      gameList: [],
      dialogSignature: false
    };
  },
  created() {
    this.getContractList('')
    this.getGameList();
  },
  methods: {
    // 查看预览
    selectCnontract(row) {
      if(row.sign_way == 2 && row.benefit_prove_url && row.buy_user_id == this.$store.state.userData.user_id){
        // 包赔
        window.open(`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(row.benefit_prove_url)}`, '_blank')
      } else {
        // 交易合同
        apiViewContract({id: row.id}).then(res => {
          if(res.data.url){
            window.open(res.data.url,'_blank')
          }else{
            this.$message.error("合同接口请求失败，系统版本更新后开放预览！ ")
          }
        }).catch(err => {
          this.$message.error("合同接口请求失败，系统版本更新后开放预览！ ")
        })
      }
    },
    /**
     * @description: 获取合同信息列表
     * @param {*}
     * @return {*}
     */
    getContractList(s) {
      this.query.page = s != '' ? s : this.query.page
      apiContractList(this.query).then(res => {
        this.tableData = res.data.list
        this.totalCount = res.data.total
      })
    },
    handleCurrentChange(val) {
      this.query.page = val
      this.getContractList('')
    },
    /**
     * @description: 下载合同
     * @param {*}
     * @return {*}
     */
    downContract(row) {
      if(row.sign_way == 2 && row.benefit_prove_url && row.buy_user_id == this.$store.state.userData.user_id){
        // 包赔
        window.open(row.benefit_prove_url, '_blank')
      } else {
        apiDownloadContract({id: row.id}).then(res => {
          if(res.data.url){
            window.open(res.data.url,'_blank')
          }else{
            this.$message.error("合同接口请求失败，系统版本更新后开放下载！")
          }
        }).catch(err => {
          this.$message.error("合同接口请求失败，系统版本更新后开放下载！")
        })
      }
    },
    /**
     * @description: 签署合同
     * @param {*}
     * @return {*}
     */
    signContract(item) {
      if(item.contract_no !== null && item.contract_no !== ''){
        // apiContractVerify({
        //   id: item.id,
        //   return_url: `${process.env.VUE_APP_WEBSITE}/personalCenter/contractCenter`
        // }).then(res => {
        //   if(res.data.url.length > 10){
        //     window.open(res.data.url, '_blank')
        //   } else {
            apiContractSigned({id: item.id}).then(response => {
              window.open(response.data.url, '_blank')
            }).catch(err => {
              this.$message.error(err.msg)
            })
          // }
        // })
      } else {
        this.$message.error('暂无合同签署文件')
        // this.dialogSignature = true
      }
    },
    /**
     * @description: 下载包赔文件
     * @return {*}
     */
    downIndemnity(url) {
      window.open(url, '_blank')
    },
    /**
     * @description: 搜索
     * @param {*}
     * @return {*}
     */
    handleSearch(s) {
      this.getContractList(s)
    },
    /**
     * 获取游戏列表
     */
    getGameList() {
      apiGameList().then((res) => {
        this.gameList = [];
        res.data.forEach((item, index) => {
          // if(item.assess_on == 1){
          let option = new Object();
          option.game_id = item.game_id;
          option.game_name = item.game_name;
          this.gameList.push(option);
          // }
        });
        this.gameList.push({game_id: '-1', game_name: '其他'})
      });
    },
  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
.contract-info {
  padding: 20px;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after{
    box-sizing: border-box;
  }

  /deep/ .el-tabs--top {
    min-height: 40px;
    height: auto;
    padding: 4px 0 8px;
    background: transparent;
    border-radius: 0;
    display: flex;
    align-items: center;
    .el-tabs__header {
      margin: 0;
      .el-tabs__nav-wrap {
        &::after {
          display: none;
        }
        .el-tabs__nav-scroll {
          .el-tabs__nav {
            display: flex;
            align-items: center;
            gap: 8px;
            .el-tabs__item {
              position: relative;
              min-width: 84px;
              height: 34px;
              padding: 0 16px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 4px;
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: var(--text-secondary, #5A5F6B);
              line-height: 20px;
              transition: color .2s ease, background .2s ease, box-shadow .2s ease;
              &:hover {
                color: var(--text-main, #1A1D24);
                background: var(--bg-tag, #F0EDE8);
              }
              &.is-active {
                color: #FFFFFF;
                font-size: 14px;
                font-weight: 500;
                background: transparent;
                box-shadow: none;
                &::before {
                  content: "";
                  position: absolute;
                  inset: 0;
                  z-index: -1;
                  border-radius: 4px;
                  background: var(--bg-dark, #1A1D24);
                  transform: skewX(-12deg);
                }
                &::after {
                  content: "";
                  position: absolute;
                  left: 16px;
                  right: 16px;
                  bottom: -7px;
                  height: 3px;
                  border-radius: 2px;
                  background: var(--primary, #FF5A1F);
                }
                &:hover {
                  background: transparent;
                }
              }
            }
            .el-tabs__active-bar {
              display: none;
            }
          }
        }
      }
    }
  }
  .contract-search {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    min-height: 64px;
    margin: 16px 0 18px;
    padding: 12px;
    background: var(--bg-tag, #F7F5F2);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    > div {
      display: flex;
      align-items: center;
      margin-right: 0;
      > span {
        margin-right: 8px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        white-space: nowrap;
      }
      .el-input {
        width: 132px;
        margin-left: 0;
      }
      /deep/.el-input__inner {
        height: 38px;
        padding: 0 32px 0 12px !important;
        background: var(--bg-card, #FFFFFF);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        color: var(--text-main, #111827);
        font-size: 14px;
        transition: border-color .2s ease, box-shadow .2s ease;
      }
      /deep/.el-input.is-focus .el-input__inner,
      /deep/.el-input__inner:focus{
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }
      .el-select{
        width: 132px;
        margin-left: 0;
      }
      /deep/.el-select-dropdown{
        border-color: var(--border-soft, #E8E4DE);
        border-radius: 4px;
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      }
      /deep/.el-select-dropdown__item{
        color: var(--text-secondary, #5A5F6B);
      }
      /deep/.el-select-dropdown__item.hover,
      /deep/.el-select-dropdown__item:hover{
        background: var(--bg-tag, #F0EDE8);
      }
      &.search-btn {
        margin-left: auto;
        span {
          font-size: 14px;
          color: #ffffff;
        }
        .el-button {
          min-width: 92px;
          height: 38px;
          line-height: 38px;
          background: var(--primary, #FF5A1F);
          border-radius: 3px;
          padding: 0;
          border: none;
          box-shadow: none;
          font-size: 14px;
          font-weight: 500;
          transition: background .2s ease;
          &:hover{
            background: var(--primary-hover, #E84A12);
          }
        }
      }
      .el-select-dropdown__item.selected {
        color: var(--primary, #FF5A1F);
        font-weight: 500;
      }
    }
  }
  .contract-table {
    overflow: hidden;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);
    /deep/ .el-table {
      color: var(--text-main, #111827);
      &:before {
        display: none;
      }

      .el-table__body-wrapper{
        overflow-x: auto;
      }

      .el-table__fixed-right{
        right: -1px !important;
        overflow: hidden;
        box-shadow: -8px 0 18px rgba(26, 29, 36, 0.08);
      }

      .el-table__fixed-right:before{
        display: none;
      }

      .el-table__fixed-right,
      .el-table__fixed-right-patch{
        background: var(--bg-card, #FFFFFF);
      }

      .el-table__fixed-body-wrapper,
      .el-table__fixed-header-wrapper{
        overflow: hidden;
      }

      .el-table__fixed-right .cell{
        overflow: visible;
      }

      thead {
        height: 48px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 500 !important;
        color: var(--text-secondary, #5A5F6B);
        tr,
        th {
          background: var(--bg-tag, #F7F5F2);
          border-bottom: 1px solid var(--border-soft, #E8E4DE);
        }
        th{
          font-weight: 500 !important;
        }
      }
      tbody {
        .el-table__row {
          text-align: center;
          transition: background .2s ease;
          &:hover td{
            background: var(--bg-tag, #F7F5F2);
          }
          td{
            height: 64px;
            border-bottom: 1px solid var(--border-soft, #E8E4DE);
            color: var(--text-secondary, #5A5F6B);
          }
          .contract-link,
          .contract-no-border{
            height: 30px;
            min-width: 68px;
            width: auto;
            padding: 0 10px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border: 1.5px solid var(--bg-dark, #1A1D24);
            border-radius: 3px;
            background: #FFFFFF;
            box-shadow: none;
            color: var(--text-main, #1A1D24);
            font-size: 13px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 500;
            line-height: 20px;
            margin-right: 0;
            transition: border-color .2s ease, box-shadow .2s ease, background .2s ease, color .2s ease;
            i {
              font-size: 15px;
              margin-right: 5px;
            }
            &:hover {
              color: var(--text-main, #1A1D24);
              background: var(--bg-tag, #F0EDE8);
              border-color: var(--bg-dark, #1A1D24);
              box-shadow: none;
            }
          }
          .contract-link{
            border-color: transparent;
            background: var(--primary, #FF5A1F);
            box-shadow: none;
            color: #FFFFFF;

            &:hover {
              color: #FFFFFF;
              background: var(--primary-hover, #E84A12);
              border-color: transparent;
              box-shadow: none;
            }
          }
          .no-hover{
            &:hover{
              color: var(--text-secondary, #5A5F6B);
              border-color: var(--border-soft, #E8E4DE);
            }
          }
          .link_group{
            border: 1px solid var(--border-soft, #E8E4DE);
            border-radius: 4px;
            padding: 0 11px;
            height: 28px;
            display: inline-block;
            width: 110px;
            box-sizing: border-box;

            span{
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: var(--text-main, #111827);
              line-height: 28px;
              cursor: pointer;
            }
            a{
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: var(--text-main, #111827);
              line-height: 28px;
              &:first-child::after{
                content: '';
                height: 18px;
                width: 1px;
                background: var(--border-soft, #E8E4DE);
                display: block;
                margin: 0 5.5px;
              }
              &:hover{
                color: var(--text-main, #1A1D24);
              }
            }
          }
          .all-over,
          .no-over {
            min-width: 74px;
            height: 26px;
            padding: 0 10px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            font-size: 13px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 500;
            line-height: 20px;
          }
          .all-over{
            color: var(--new, #00C16E);
            background: var(--bg-tag, #F0EDE8);
          }
          .no-over {
            color: var(--gold, #C9974D);
            background: var(--bg-tag, #F0EDE8);
          }
          .ing-over{
            min-width: 74px;
            height: 26px;
            padding: 0 10px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            color: var(--gold, #C9974D);
            background: var(--bg-tag, #F0EDE8);
            font-size: 13px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 500;
          }
          .cancel-over{
            min-width: 74px;
            height: 26px;
            padding: 0 10px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            color: var(--text-muted, #9AA0AC);
            background: var(--bg-tag, #F0EDE8);
            font-size: 13px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 500;
          }
        }
      }
      .cell{
        padding: 0 8px;
        line-height: 20px;
      }

      .el-table__fixed-right th:last-child .cell,
      .el-table__fixed-right .el-table__row td:last-child .cell{
        display: flex;
        align-items: center;
      }

      .el-table__fixed-right th:last-child .cell{
        justify-content: center;
      }

      .el-table__fixed-right .el-table__row td:last-child .cell{
        justify-content: flex-start;
        gap: 8px;
        padding: 0 16px;
      }
    }

    .contract-empty{
      min-height: 300px;
      padding: 64px 36px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .contract-pages {
    display: flex;
    justify-content: center;
    min-height: 68px;
    margin-top: 0;
    background: var(--bg-card, #FFFFFF);
  }
  .el-input.is-active .el-input__inner,
  .el-input__inner:focus {
    border-color: var(--primary, #FF5A1F);
  }
  /deep/.contract-before{
    overflow: visible;
    background: var(--bg-card, #FFFFFF);
    border-radius: 4px;
    box-shadow: none;
    filter: drop-shadow(0 18px 46px rgba(26, 29, 36, 0.14));
    .el-dialog__header{
      padding: 0 !important;
    }
    .el-dialog__headerbtn{
      top: 14px;
      right: 14px;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .el-dialog__close{
      color: var(--text-muted, #9AA0AC);
      font-size: 18px;
      transition: color .2s ease, transform .2s ease;
    }
    .el-dialog__headerbtn:hover .el-dialog__close{
      color: var(--text-main, #1A1D24);
      transform: rotate(90deg);
    }
    .el-dialog__body{
      padding: 0 !important;
      background: var(--bg-card, #FFFFFF);
      border-radius: 4px;
    }
    .signature-dia{
      position: relative;
      padding: 26px 34px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 4px;
      background: var(--bg-card, #FFFFFF);
      text-align: center;
    }
    .signature-icon{
      width: 56px;
      height: 56px;
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      background: var(--bg-tag, #F0EDE8);
      color: var(--text-main, #1A1D24);
      font-size: 28px;
    }
    .signature-footer{
      margin: 0 0 8px;
      font-size: 18px;
      line-height: 24px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: var(--text-main, #111827);
    }
    .signature-desc{
      width: 100%;
      max-width: 289px;
      margin: 0 0 24px;
      font-size: 15px;
      line-height: 24px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
    }
    .signature-confirm{
      width: 200px;
      height: 40px;
      margin-top: 0;
      padding: 0;
      border: none;
      border-radius: 3px;
      background: var(--primary, #FF5A1F);
      box-shadow: none;
      font-size: 15px;
      line-height: 40px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      transition: background .2s ease;
    }
    .signature-confirm:hover{
      background: var(--primary-hover, #E84A12);
    }
    .close{
      position: absolute;
      width: 30px;
      height: 30px;
      bottom: -42px;
      left: calc(50% - 15px);
      cursor: pointer;
      opacity: .92;
      transition: opacity .2s ease, transform .2s ease;
    }
    .close:hover{
      opacity: 1;
      transform: rotate(90deg);
    }
  }
}
</style>
